module.exports = __webpack_public_path__ + "img/MadeAll_Icon(Light).7bb917ba.svg";